import {ChangeDetectorRef, Component} from '@angular/core';
import {Store} from "@ngrx/store";
import {AuthService, ConfigService, StorageService} from "@cosbeni/auth";
import {DatabaseService} from "@cosbeni/database";
import {GapiSession} from "../gapi/gapi.session";
import {LoadUserAction} from "../ngrx/actions/user.action";
import * as wjcCore from "@grapecity/wijmo";


@Component({
    selector: 'app-container',
    templateUrl: './container.component.html'
})
export class ContainerComponent {
    database: string;
    user: any;
    isGoogleSignedIn: boolean = false;
    googleEnabled: boolean = true;

    constructor(private store: Store<any>, private auth: AuthService, private databaseService: DatabaseService, private storage: StorageService, private config: ConfigService, private gapiSession: GapiSession, private cdRef:ChangeDetectorRef) {
        this.store.dispatch(new LoadUserAction())
        this.store.select<any>("kaitoriyaFeature").subscribe((kaitoriya: any) => {
            if(wjcCore.isObject(kaitoriya.user)){
                this.user = kaitoriya.user.user;
            }
        });
        this.database = this.storage.get("database");
        this.googleEnabled = this.gapiSession.enabled;
        if (this.gapiSession.isSignedIn()) {
            this.isGoogleSignedIn = true;
        }
    }

    logout() {
        this.auth.logout().subscribe(response => {
            console.log("LOGOUT SUCCESSFUL!!")
        });
        this.storage.remove(this.database + "_url");
    }

    googleSignIn() {
        this.gapiSession.signIn().then(() => {
            if (this.gapiSession.isSignedIn()) {
                this.isGoogleSignedIn = true;
                this.cdRef.detectChanges();
            }
        });
    }

    googleSignOut() {
        this.gapiSession.signOut();
        this.isGoogleSignedIn = false;
    }

    public hasRole(name: string): boolean {
        let result: boolean = false;
        if (wjcCore.isObject(this.user) && wjcCore.isArray(this.user.roles)) {
            for (let role of this.user.roles) {
                if (role.name == name) {
                    result = true;
                }
            }
        }
        return result;
    }

    public enableMenu(name: string): boolean {
        let result: boolean = true;
        if (this.user[name])
            result = false;
        return result;
    }
}
